import { render, staticRenderFns } from "./ContractRemark.vue?vue&type=template&id=078c9b64&scoped=true"
import script from "./ContractRemark.vue?vue&type=script&setup=true&lang=js"
export * from "./ContractRemark.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ContractRemark.vue?vue&type=style&index=0&id=078c9b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078c9b64",
  null
  
)

export default component.exports